import { TechnicalElementType } from "@rhinov/savane-js";
import { ComponentWidget } from "./ComponentWidget";
import { _ASSET_TYPE, getAsset, getToken } from "@rhinov/asset-manager-service";



export class TechnicalElementsComponentWidget  extends ComponentWidget {
    constructor (component: TechnicalElementType, index: number) {
        super(component, index);
        
    }

    init(endCallback: CallableFunction) {
        getAsset(_ASSET_TYPE.TECHNICAL_ELEMENTS, (this.component as TechnicalElementType).technicalElementTypeId, getToken(),
            (res: any) => {
                (this.component as any).infos = res;
                endCallback();
        });

    }
    
    html(): string {
        return super.CommonHeader(false);
    }
}